export default __webpack_public_path__ + "assets/audios/d7a5c96f6409ce8758e27bd3901948f8.mp3";